export const SET_CASE_LIST_FILTER = 'SET_CASE_LIST_FILTER'
export const RESET_CASE_LIST_FILTER = 'RESET_CASE_LIST_FILTER'



// WEBPACK FOOTER //
// ./src/components/CaseList/actions/actionTypes.js